<template>
  <jade-feedback
    :title="$t('title')"
    :description="$t('description')"
    variant="positive"
  >
    <jade-button
      size="small"
      @click="goToDisputes"
      >{{ $t('button') }}</jade-button
    >
  </jade-feedback>
</template>
<script>
import { JadeFeedback, JadeButton } from '@jade'
export default {
  name: 'FinishedDocumentation',
  components: {
    JadeButton,
    JadeFeedback
  },
  methods: {
    goToDisputes () {
      this.$router.push({ name: 'chargebacks' })
    }
  }
}
</script>
<i18n>
    {
        "pt-BR": {
            "title": "Envio da documentação concluída",
            "description": "O documento enviado será analisado pela nossa equipe em até 1 dia útil.",
            "button": "Ir para contestações"
        },
        "en-US": {
            "title": "Documentation sent",
            "description": "The document sent will be analyzed by our team within 1 business day.",
            "button": "Go to disputes"
        }
    }
</i18n>
